import React, { Component } from 'react';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import classnames from 'classnames';
import './ConsoleTile.css';
import { IconLoader } from 'common/IconLoader';

export default class ConsoleTile extends Component {
  constructor(props) {
    super(props);

    /*navbar, innerPagePadding, innerConsoleTilePadding*/
    this.externalPageWidthOffset = 56 + 48 + 26 + 20;

    this.state = {
      height: props.defaultHeight,
      resizeWidth: window.innerWidth - this.externalPageWidthOffset,
      dragging: false,
      dragPosition: 0
    };

    this.height = props.defaultHeight ? props.defaultHeight : 0;
  }

  componentDidUpdate() {
    if (this.props.getHeightRenderVal) {
      this.props.getHeightRenderVal(this.state.height);
    }

    if (this.props.getWidthRenderVal) {
      this.props.getWidthRenderVal(this.state.resizeWidth);
    }
  }

  updateResizeWidth = () => {
    this.setState({ resizeWidth: window.innerWidth - this.externalPageWidthOffset });
  };

  componentDidMount() {
    const maxHeight = Math.round(this.props.defaultHeight * 1.25);
    const minHeight = Math.round(this.props.defaultHeight * 0.75);

    window.addEventListener('mousemove', (evt) => {
      if (!this.state.dragging || this.height + evt.movementY < minHeight || this.height + evt.movementY > maxHeight) {
        return;
      }

      this.height += evt.movementY;

      this.height = Math.min(this.height, maxHeight);
      this.height = Math.max(this.height, minHeight);

      console.log('height: ', this.height);
      this.setState({ height: this.height });
    });

    window.addEventListener('mouseup', (evt) => {
      if (this.state.dragging) {
        this.setState({ dragging: false });
      }
    });

    window.addEventListener('resize', this.updateResizeWidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateResizeWidth);
  }

  render() {
    let contents = null;

    if (this.props.tileHeader == null && this.props.title) {
      contents = <div className="ConsoleTile_GenericHeaderDiv">{this.props.title}</div>;
    }

    if (this.props.tileHeader != null) {
      contents = this.props.tileHeader;
    }

    return (
      <div
        className={classnames({
          consoleTile: true,
          ...(this.props.customClass && { [this.props.customClass]: true })
        })}
      >
        <div className="ConsoleTile_Header">{contents}</div>
        <div className="ConsoleTile_Content" style={this.props.resizable ? { height: this.state.height + 'px' } : {}}>
          {this.props.children}
        </div>
        {this.props.resizable ? (
          <div className="ConsoleTile_Resize_Div">
            <div
              draggable={true}
              onDragStart={(evt) => {
                evt.preventDefault();
                let evt_cpy = { ...evt };
                console.log('event:', evt_cpy);
                this.setState({ dragging: true });
              }}
            >
              <SvgAF img={IconLoader.icon_vertical_expand} hover={IconLoader.icon_vertical_expand_hover} />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
